export function isActivatedClientStatus(
  status: string | null | undefined,
): boolean {
  return status?.trim().toLocaleLowerCase() === "activated";
}
